module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-57x57.50143cd560f75f60fd7d0522c2e8e8eb.png";